module.exports = __webpack_public_path__ + "static/img/t44.3bb03a98.png";